import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

PriceListsDuplicateModalController.$inject = ['$scope', '$uibModalInstance', 'priceLists', 'currentPriceList'];

function PriceListsDuplicateModalController(
  $scope: IScope & {
    cancel: TODO;
    done: TODO;
    errors: TODO;
    hasErrors: TODO;
    init: TODO;
    isUnique: TODO;
    model: TODO;
    success: TODO;
    trim: TODO;
  },
  $uibModalInstance: UIBModal<string>,
  priceLists: TODO,
  currentPriceList: TODO
) {
  $scope.errors = [];

  $scope.model = {
    name: currentPriceList.name + ' Copy',
  };

  $scope.init = function () {};

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.trim = function (s) {
    return s.replace(/\s+/g, '').toLowerCase();
  };

  $scope.isUnique = function () {
    const trimmedCurrent = $scope.trim($scope.model.name);
    let r = true;

    for (let i = 0, ii = priceLists.length; i < ii; i++) {
      const trimmed = $scope.trim(priceLists[i].name);
      if (trimmedCurrent === trimmed) {
        r = false;
        break;
      }
    }

    return r;
  };

  $scope.done = function () {
    if ($scope.isUnique()) {
      if ($scope.model.name.replace(/\s+/g, '').length > 0) {
        $scope.success();
      } else {
        $scope.errors.push({ message: 'Please enter a valid name' });
      }
    } else {
      $scope.errors.push({ message: 'A price list named "' + $scope.model.name + '" already exists' });
    }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close($scope.model.name);
  };

  $scope.init();
}

export const PriceListsDuplicateModalControllerModule = angular
  .module('acme.view.application.pricing.lists.duplicateModal.controllers', [])
  .controller('PriceListsDuplicateModalController', PriceListsDuplicateModalController).name;
